// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53bb0ed3","455":"603e9230"}[chunkId] + ".chunk.js";
};